import { Component, OnInit, ViewChild, AfterViewInit, Input, OnChanges, SimpleChanges, Host, ElementRef, Renderer2 } from '@angular/core';
import { manglishAlternatesFor } from '@otas/utils/directives/extras/manglish-layout';
import { VirtualKeyboardComponent } from '../virtual-keyboard/virtual-keyboard.component';
import { fromEvent } from 'rxjs';
@Component({
    selector: 'app-manglish-suggestion',
    templateUrl: './manglish-suggestion.component.html',
    styleUrls: ['./manglish-suggestion.component.scss'],
    standalone: false
})
export class ManglishSuggestionComponent implements OnInit, AfterViewInit, OnChanges {
  visible = true;
  @Input() manglishPattern = null;
  @ViewChild('divParent', { static: false }) divParentRef: ElementRef;
  letters = [];
  isFocused: boolean;
  /** Index arrow-highlighted by the user; null = no keyboard selection (highlight follows the pattern). */
  selectedIndex: number | null = null;
  constructor(@Host() private virtualKeyboard: VirtualKeyboardComponent, private renderer: Renderer2) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {


      fromEvent(this.virtualKeyboard.inputField.elementRef.nativeElement, 'focus').subscribe((event) => {

        this.isFocused = document.activeElement === this.virtualKeyboard.inputField.elementRef.nativeElement;
      });
      fromEvent(this.virtualKeyboard.inputField.elementRef.nativeElement, 'blur').subscribe((event) => {

        this.isFocused = document.activeElement === this.virtualKeyboard.inputField.elementRef.nativeElement;
      });
      fromEvent(this.virtualKeyboard.inputField.elementRef.nativeElement, 'keydown').subscribe((event: KeyboardEvent) => {

        this.isFocused = false;
        this.onInputKeydown(event);
      });
    }, 300);
  }

  ngOnChanges(changes: SimpleChanges) {
    // Typing / Tab-cycling moved the pattern: drop the keyboard selection.
    this.selectedIndex = null;
    if (this.manglishPattern) {
      // A fresh pattern reopens an Escape-closed list.
      this.visible = true;
      // Precomputed index - same keys, same order as the old per-change
      // _.filter scan over Object.keys(MANGLISH_LAYOUT) (spec-pinned in
      // manglish-layout.spec.ts).
      this.letters = manglishAlternatesFor(this.manglishPattern).slice();
    } else {
      this.letters = [];
      if (this.divParentRef) {
        const id = this.divParentRef.nativeElement.getAttribute('aria-describedby');
        if (document.body.querySelector('#' + id)) {
          this.renderer.removeChild(document.body, document.body.querySelector('#' + id));
        }
      }
    }

  }

  /** The list is interactable: pattern active, more than one alternate, not Escape-closed. */
  get isOpen(): boolean {
    return this.visible && !!this.manglishPattern && this.letters.length > 1;
  }

  /**
   * Keyboard traversal, driven by the HOST INPUT's keydown (the list itself
   * is never focused): ArrowUp/ArrowDown move the highlight (wrapping),
   * Enter commits the highlighted alternate through the same write path as
   * Tab-cycling, Escape closes the list. Every branch is gated on the open
   * list, so inputs whose list is closed or empty type exactly as before;
   * Enter is only consumed once the user has arrow-highlighted something.
   * Escape is deliberately NOT consumed (screens keep their existing Escape
   * behaviors - they always fired with the list showing before). Tab is not
   * handled here at all: it keeps cycling alternates in the directive.
   */
  onInputKeydown(event: KeyboardEvent) {
    if (!this.isOpen) {
      return;
    }
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      this.moveSelection(event.key === 'ArrowDown' ? 1 : -1);
    } else if (event.key === 'Enter') {
      if (this.selectedIndex !== null) {
        event.preventDefault();
        event.stopPropagation();
        this.commitSelected();
      }
    } else if (event.key === 'Escape') {
      this.visible = false;
      this.selectedIndex = null;
    }
  }

  moveSelection(delta: 1 | -1) {
    const count = this.letters.length;
    if (this.selectedIndex === null) {
      // Start from the alternate the pattern currently sits on (Tab parity).
      const current = this.letters.indexOf(this.manglishPattern);
      this.selectedIndex = current !== -1
        ? (current + delta + count) % count
        : (delta === 1 ? 0 : count - 1);
    } else {
      this.selectedIndex = (this.selectedIndex + delta + count) % count;
    }
  }

  commitSelected() {
    const letter = this.selectedIndex === null ? null : this.letters[this.selectedIndex];
    const input = this.virtualKeyboard.inputField;
    if (letter && input && typeof input.applyAlternate === 'function') {
      input.applyAlternate(letter);
    }
  }

  isActive(letter, index: number) {
    return this.selectedIndex !== null ? this.selectedIndex === index : this.manglishPattern === letter;
  }
}
/*
import { Component, OnInit, ViewChild, AfterViewInit, Input, OnChanges, SimpleChanges, Host } from '@angular/core';
import { MANGLISH_LAYOUT } from '@otas/utils/directives/extras/manglish-layout';
import * as _ from 'underscore';
import { VirtualKeyboardComponent } from '../virtual-keyboard/virtual-keyboard.component';
import { fromEvent } from 'rxjs';
import { take } from 'rxjs/operators';
import { ManglishWordPipe } from './pipe/manglish-word.pipe';
@Component({
  selector: 'app-manglish-suggestion',
  templateUrl: './manglish-suggestion.component.html',
  styleUrls: ['./manglish-suggestion.component.scss']
})
export class ManglishSuggestionComponent implements OnInit, AfterViewInit, OnChanges {
  visible = true;
  @Input() manglishPattern;
  manglishLetter;
  letters = [];
  isFocused: boolean;
  manglishPipe = new ManglishWordPipe();
  constructor(@Host() private virtualKeyboard: VirtualKeyboardComponent) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    console.log(this.virtualKeyboard);
    setTimeout(() => {


      fromEvent(this.virtualKeyboard.inputField.nativeElement, 'focus').subscribe((event) => {

        this.isFocused = document.activeElement === this.virtualKeyboard.inputField.nativeElement;
      });
      fromEvent(this.virtualKeyboard.inputField.nativeElement, 'blur').subscribe((event) => {

        this.isFocused = document.activeElement === this.virtualKeyboard.inputField.nativeElement;
      });
      fromEvent(this.virtualKeyboard.inputField.nativeElement, 'keydown').subscribe((event) => {

        this.isFocused = false;
      });
    }, 300);
  }

  ngOnChanges(changes: SimpleChanges) {
    const charMap = MANGLISH_LAYOUT;

    if (this.manglishPattern) {
      this.letters = _.filter(Object.keys(charMap), (e: string) => {
        const splitLetter = this.manglishPattern.split(/(\d+)/)[0];
        return e === splitLetter || e === splitLetter + '2' ||
          e === splitLetter + '3' || e === splitLetter + '4' ||
          e === splitLetter + '5' || e === splitLetter + '6' || e === splitLetter + '7';
      });
      const inputValue = this.virtualKeyboard.inputField.nativeElement.value;
      const previousString = inputValue.substring(inputValue.length - 4, inputValue.length - 2);
      // console.log(, 'substring=====>');
      const prevKey = _.find(Object.keys(charMap), e => charMap[e] === previousString);
      const prevChar = this.manglishPipe.transform(prevKey);
      if (prevKey && this.manglishPattern.charAt(0) === prevKey) {
        this.letters = _.map(this.letters, e => prevChar + this.manglishPipe.transform(e));
      } else {
        this.letters = _.map(this.letters, e => this.manglishPipe.transform(e));

      }

    } else {
      this.letters = [];
    }

  }
  isActive(letter) {
    const charMap = MANGLISH_LAYOUT;
    const inputValue = this.virtualKeyboard.inputField.nativeElement.value;
    const previousString = inputValue.substring(inputValue.length - 4, inputValue.length - 2);
    const prevKey = _.find(Object.keys(charMap), e => charMap[e] === previousString);
    const prevChar = this.manglishPipe.transform(prevKey);
    if (prevKey && this.manglishPattern.charAt(0) === prevKey) {
      return prevChar + this.manglishPipe.transform(this.manglishPattern) === letter;
    } else {
      return this.manglishPipe.transform(this.manglishPattern) === letter;

    }
  }
}

*/